export default "__VITE_ASSET__BKySu_P3__"